import { WaitingLineType } from './graphql/graphql';

// eslint-disable-next-line import/prefer-default-export
export function isFreeTierWaitingLine(waitingLineType: WaitingLineType) {
  switch (waitingLineType) {
    case WaitingLineType.Free:
    case WaitingLineType.Licensed:
      return true;
    default:
      return false;
  }
}
